<template>
  <button aria-haspopup="true" :aria-expanded="isActive">
    <span>{{ name }}</span>
    <i class="far fa-chevron-down"></i>
  </button>
</template>

<script>
  export default {
    name: 'MegaMenuButton',
    props: {
      name: String,
      isActive: Boolean,
    }
  }
</script>

<style lang="scss" scoped>
  button  {
    height: 60px;
    padding: 0px;
    margin: 0px;
    border: 0px;
    background: transparent;
    display: flex;
    align-items: center;
    float: left;
    margin-right: 40px;

    &:focus {
      outline: none;
      box-shadow: none; 
    }

    span {
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding: 10px 0px 0px 0px;
      height: 60px;
      font-size: 18px;
      line-height: 20px;
      font-family: 'Seattle Text';
      font-weight: normal;
      text-transform: uppercase;
      border-bottom: 5px solid transparent;
    }

    &:focus span,
    &:hover span,
    &[aria-expanded="true"] span {
      border-bottom: 5px solid #0046ad;
    }

    svg {
      color: #0046ad;
      margin-left: 4px;
    }
    &[aria-expanded="true"] svg {
      transform: rotate(180deg);
    }
  }

  /* MAC FIX Seattle Font */
  .mac.notFF button span {
    padding-top: 5px;
  }
</style>
